import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ALL_PLAYERS_KEY } from '../player/usePlayers';
import { RankingChangeRequest } from '../interface/apiModels';
import { restClient } from '../../../App';
import { ApiException } from '../interface/ApiException';
import { ApiError } from '../interface/ApiError';

export const useCreateRankingEvents = (): UseMutationResult<void, ApiException<ApiError>, RankingChangeRequest[]> => {
  const queryClient = useQueryClient();
  return useMutation(createRankingEvents, {
    onSuccess: () => {
      return queryClient.invalidateQueries(ALL_PLAYERS_KEY);
    },
  });
};

const createRankingEvents = async (requests: RankingChangeRequest[]) => {
  return await restClient.createRankingChange(requests);
};
